/**
 * US County Data
 * Uses state-counties-us package for comprehensive county data across all 50 states
 * Source: https://www.npmjs.com/package/state-counties-us
 */

import scus from 'state-counties-us';

/**
 * Gets all counties for a given US state
 * Supports all 50 US states
 *
 * @param {string} stateCode - Two-letter state code (e.g., 'NC', 'CA', 'TX')
 * @returns {string[]} - Array of county names with "County" suffix
 */
export function getCountiesByState(stateCode) {
  if (!stateCode) {
    return [];
  }

  try {
    // Get counties from the package (returns array of county names without "County" suffix)
    const counties = scus.getCountiesByState(stateCode.toUpperCase());

    if (!counties || counties.length === 0) {
      console.warn(`No counties found for state code: ${stateCode}`);
      return [];
    }

    // Add "County" suffix to each name for consistency
    const countiesWithSuffix = counties.map(county => {
      // Handle special cases (e.g., "St. Louis" -> "St. Louis County")
      if (county.endsWith(' County') || county.endsWith(' Parish') || county.endsWith(' Borough')) {
        return county;
      }
      return `${county} County`;
    });

    return countiesWithSuffix.sort();
  } catch (error) {
    console.error(`Error loading counties for ${stateCode}:`, error);
    return [];
  }
}

/**
 * Gets all US state codes
 * @returns {string[]} - Array of two-letter state codes
 */
export function getAllStates() {
  return scus.getStates();
}
